"use client";
import { UserRole } from "@prisma/client";
import { redirect, usePathname, useSearchParams } from "next/navigation";
import React from "react";
import { SessionUser } from "@/auth/session";
import { getUserOrThrow } from "./server/getUser";

function ProtectedRoute({
  children,
  user,
}: {
  children: React.ReactNode;
  user: SessionUser | null;
}) {
  const pathname = usePathname();

  // Manda a la página de login si no hay usuario

  if (user === null) {
    const params = new URLSearchParams();
    params.set("next", pathname);
    redirect(`/admin/login?${params}`);
  }

  if (user.forcePasswordChange && pathname !== "/admin/cambiar-clave") {
    const params = new URLSearchParams();
    params.set("next", pathname);
    redirect(`/admin/cambiar-clave?${params}`);
  }

  return children;
}

export default ProtectedRoute;

export const grantedAccess = (
  pathname: string,
  user: SessionUser,
  path: string,
  roles: UserRole[]
) => {
  if (user === null) return false;

  if (
    new RegExp(`^\\/${path}(\\/.*)?$`).test(pathname) &&
    (roles.some((role) => user.roles.includes(role)) ||
      user.roles.includes("ADMIN"))
  )
    return true;

  return false;
};
